import React from 'react';
import { Badge } from 'react-bootstrap';
import moment from 'moment';
import AuditLogDetails from './AuditLogDetails';

const AuditLogRow = ({ log, onRollback }) => {
  const getActionBadge = (action) => {
    switch (action) {
      case 'CREATE': return <Badge variant="success">CREATE</Badge>;
      case 'UPDATE': return <Badge variant="info">UPDATE</Badge>;
      case 'DELETE': return <Badge variant="danger">DELETE</Badge>;
      case 'IMPORT': return <Badge variant="primary">IMPORT</Badge>;
      default: return <Badge variant="secondary">{action}</Badge>;
    }
  };

  const canRollback = log.action === 'UPDATE' && 
                      log.targetModel === 'Transaction' && 
                      !log.details?.isRollback;

  return (
    <tr key={log._id}>
      <td className="small text-nowrap text-muted">
        {moment(log.timestamp).format('MMM D, h:mm a')}
      </td>
      <td className="small font-weight-bold">
        {log.userId?.name || 'Unknown'}
      </td>
      <td>
        <Badge variant="light" className="border">
          {log.projectId?.name || 'System'}
        </Badge>
      </td>
      <td>{getActionBadge(log.action)}</td>
      <td className="small text-muted">{log.targetModel}</td>
      <td>
        <div className="d-flex justify-content-between align-items-start">
          <div className="flex-grow-1">
            <AuditLogDetails log={log} />
          </div>
          {canRollback && (
            <button 
              onClick={() => onRollback(log._id)} 
              disabled={log.rolledBack}
              className={`btn btn-sm ml-3 px-3 py-1 font-weight-bold shadow-sm ${log.rolledBack ? 'btn-light text-muted' : 'btn-outline-danger'}`}
              style={{ fontSize: '0.65rem', whiteSpace: 'nowrap' }}
              title={log.rolledBack ? "Already rolled back" : "Undo this change"}
            >
              <i className={`fas ${log.rolledBack ? 'fa-check' : 'fa-undo'} mr-1`}></i> 
              {log.rolledBack ? 'Rolled Back' : 'Rollback'}
            </button>
          )}
        </div>
      </td>
    </tr>
  );
};

export default AuditLogRow;
